import { Routes } from '@angular/router';
import { ScopeGuard } from '../auth/services/scope.guard';
import { SCOPES } from 'src/app/app.constants';

export const SALES_RULES_ROUTES: Routes = [
  {
    path: ':id',
    loadComponent: () =>
      import('./components/sale-rule-edit/sale-rule-edit.component').then((m) => m.SaleRuleEditComponent),
    canActivate: [ScopeGuard],
    data: { scopes: [SCOPES.admin.accounting.manage] },
  },
  {
    path: '',
    loadComponent: () =>
      import('./components/sale-rule-list/sale-rule-list.component').then((m) => m.SaleRuleListComponent),
    canActivate: [ScopeGuard],
    data: { scopes: [SCOPES.admin.accounting.manage] },
  },
];
